<div class="footer-social">
    <ul>
        <li>
            <a [routerLink]="[]"><i class="fa fa-facebook" aria-hidden="true"></i></a>
        </li>
        <li>
            <a [routerLink]="[]"><i class="fa fa-google-plus" aria-hidden="true"></i></a>
        </li>
        <li>
            <a [routerLink]="[]"><i class="fa fa-twitter" aria-hidden="true"></i></a>
        </li>
        <li>
            <a [routerLink]="[]"><i class="fa fa-instagram" aria-hidden="true"></i></a>
        </li>
        <li>
            <a [routerLink]="[]"><i class="fa fa-rss" aria-hidden="true"></i></a>
        </li>
    </ul>
</div>